import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import RefreshIcon from 'components/ReusableComponents/RefreshIcon'
import { componentModes } from 'features/NewHotelDialog/constants'
import moment from 'moment'
import { useEffect, useMemo, useState } from 'react'
import ReactTooltip from 'react-tooltip'
import subsidiariesApi from 'services/api/subsidiaries'

import Box from '../Box/index'
import EditPaymentPeriodDialog from './EditPaymentPeriodDialog'
import styles from './PrepayPreferences.module.scss'
import { SubscriptionsRow } from './SubscriptionsRow'

export const paymentPeriodOptions = {
  PostPay: 'Postpay',
  Monthly: 'Monthly',
  Quarterly: 'Quarterly',
  SemiAnnual: 'Semi-Annual',
  Annual: 'Annual'
}

const PrepayPreferences = ({ onSave, subscriptions, paymentPeriod }) => {
  const [showAddDialog, setShowAddDialog] = useState()

  const [isLoading, setIsLoading] = useState(true)
  const [nearestStartDate, setNearestStartDate] = useState()

  const [isNotPrepay, setIsNotPrepay] = useState(false)

  useEffect(() => {
    subsidiariesApi.prepayPeriod
      .get()
      .then(res => {
        setNearestStartDate(res.nearestStartDate)
        setIsLoading(false)
      })
      .catch(() => {
        setIsNotPrepay(true)
        setIsLoading(false)
      })
  }, [])

  function handleSaveNewPeriod() {
    onSave()
    setShowAddDialog(false)
  }

  const sortedSubscriptions = useMemo(() => {
    return [...subscriptions].sort((a, b) => {
      const aIsActive = moment(a.startDate).isBefore(moment())
      const bIsActive = moment(b.startDate).isBefore(moment())

      if (aIsActive && !bIsActive) return -1
      if (!aIsActive && bIsActive) return 1
      return moment(a.addedOn).diff(moment(b.addedOn))
    })
  }, [subscriptions])

  const filteredSubscriptions = useMemo(() => {
    return sortedSubscriptions.filter(s => s.startDate !== s.endDate)
  }, [sortedSubscriptions])

  if (isLoading) {
    return <LoadingIndicator />
  }

  if (isNotPrepay) {
    return null
  }

  return (
    <Box
      title="Prepay preferences"
      hasCornerButton={true}
      onClickCornerButton={() => setShowAddDialog(true)}
    >
      <ReactTooltip place="top" type="dark" effect="solid" />
      {showAddDialog && (
        <EditPaymentPeriodDialog
          onClose={() => setShowAddDialog(false)}
          onSave={handleSaveNewPeriod}
          nearestStartDate={nearestStartDate}
          mode={componentModes.paymentPeriod}
        />
      )}

      {filteredSubscriptions.map(subscription => (
        <SubscriptionsRow {...subscription} key={subscription.plan} />
      ))}

      <div className={styles.paymentPeriodInfo}>
        <div className={styles.row}>
          <div className={styles.periodTitle}>
            <RefreshIcon className={styles.refreshIcon} />
            <div className={styles.label}>
              {paymentPeriodOptions[paymentPeriod]} Payment
            </div>
          </div>
        </div>
      </div>
    </Box>
  )
}

export default PrepayPreferences
